// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3Cgq-","large":"styles_large__2B71t"};